import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    width: 294,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: 8,

      '@media screen and (max-width: 800px)': {
        width: '100%',
      },
  },
  table: {

    '& .MuiTableCell-root': {
      padding: '10px 12px',
      color: 'inherit',
      fontSize: 12,
      fontWeight: 600,
      width: '50%',
      height: 36,
      lineHeight: 1
    },

    '& .MuiTableBody-root .MuiTableRow-root:first-child': {
      // borderRight: `1px solid ${theme.palette.mainButton.contrastText}`,x
      display: 'none',
    },

    '& .MuiTableBody-root .MuiTableRow-root:last-child td': {
      borderLeft: 'none',
    },
  },
  tableHeader: {
    backgroundColor: 'rgba(104, 154, 219, 0.2)',
    height: 36,

    '& .MuiTableCell-root' : {
      borderBottom: `1px solid ${theme.palette.mainButton.contrastText}`
    }
  },
}));

export default useStyles;
